import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@components/common';

const CoordinatorCard = ({
	onClickCard,
	data : {
		Id,
		Name,
		LogoUrl,
		TotalJobCount,
		TotalLocationCount,
		PrimaryContactEmail,
		PrimaryContactPhoneNumber,
	},
}) => {
	const onClick = () => { onClickCard(Id); };

	return (
		<div className="card">
			<div className="flex margin-top-10">
				<div className="flex-1 padding-left-15 text-left">
					<a
						href={`tel:${PrimaryContactPhoneNumber}`}
						target="_blank"
						rel="noopener noreferrer"
					>
						<i className="rkf rkf-phone font-size-16" />
					</a>
				</div>
				<div className="flex-1 padding-right-15 text-right">
					<a
						href={`mailto:${PrimaryContactEmail}`}
						target="_blank"
						rel="noopener noreferrer"
					>
						<i className="rkf rkf-email font-size-16" />
					</a>
				</div>
			</div>
			<div
				className="flex-center flex-direction-column margin-top-10"
				onClick={onClick}
				role="link"
				tabIndex={-1}
				onKeyPress={null}
			>
				<Image
					src={LogoUrl || ''}
					className="height-80 width-80 border-radius-circle img-cover"
					fallbackSrc="avatar"
				/>
				<p className="text-primary font-semi-bold font-size-16 padding-top-10">{ Name }</p>
			</div>
			<div
				className="footer"
				onClick={onClick}
				role="link"
				tabIndex={0}
				onKeyPress={null}
			>
				<div className="flex-1 text-center">
					<span className="font-size-12 color-gray-mine-shaft">Jobs</span>
					<h5 className="margin-top-0 margin-top-5 font-semi-bold font-size-16">{ TotalJobCount }</h5>
				</div>
				<div className="seperator" />
				<div className="flex-1 text-center">
					<span className="font-size-12 color-gray-mine-shaft">Locations</span>
					<h5 className="margin-top-0 margin-top-5 font-semi-bold font-size-16">{ TotalLocationCount }</h5>
				</div>
			</div>
		</div>
	);
};

CoordinatorCard.propTypes = {
	onClickCard : PropTypes.func.isRequired,
	data        : PropTypes.object.isRequired,
};

export default CoordinatorCard;
